import $ from "jquery"
import * as bootstrap from 'bootstrap';

/**
 * Scripts for header fixed position
 */
window.onscroll = function() {
    fixedHeader()
};

function fixedHeader() {
    if (window.scrollY > 150) {
        $('.header').addClass('header--fixed');
        $('.nav_bar').addClass('header--fixed');
    } else {
        $('.header').removeClass('header--fixed');
        $('.nav_bar').removeClass('header--fixed');
    }
}

function bodyPaddingTop(){
    let headerHeight = $('.header').outerHeight();

    if($('#wpadminbar').length){
        const headerHeightWPAdmin = $('#wpadminbar').outerHeight();
        headerHeight = headerHeight - headerHeightWPAdmin;
    }

    $('body').css('padding-top', headerHeight + 'px');
}

// Contact Form 7 detects pick the topic input checkbox value
const pickTheTopicValue = $('.js-pick-the-topic input[type=checkbox]');

/* Temporarily disabled while waiting for decision 
function showDigitalMarketingAreas(){
    $('.js-digital-marketing-form-group').removeClass('form-group--hide');
    $('.js-digital-marketing-form-group').addClass('form-group--show');
}

function hideDigitalMarketingAreas(){
    $('.js-digital-marketing-form-group').addClass('form-group--hide');
    $('.js-digital-marketing-form-group').removeClass('form-group--show');
}

pickTheTopicValue.each(function(){
    $(this).on('click', function(){
        let pickTheTopicCheck = $(this).is(":checked");
        let pickTheTopicCheckboxValue = $(this).val();
        
        if(pickTheTopicCheckboxValue == 'Digital Marketing'){
            if(pickTheTopicCheck){
                showDigitalMarketingAreas();
            }else{
                hideDigitalMarketingAreas();
            }
        }
    });
}); 
*/

/**
 * Contact popup form on header and ecommerce page
 */
var isMobile = false;

if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}

function contactPopupCloseContactMobile(){
    $('.js-contact-popup-form, .js-contact-popup-overlay').hide();
    $('body').removeClass('o-hidden');
}

function contactPopupClose(){
    $('.js-contact-popup-svg').removeClass('active');
    $('.js-contact-popup-form, .js-contact-popup-overlay').hide();
    $('body').removeClass('o-hidden');
}

function contactThankYouPopupClose(){
    $('.js-contact-thankyou, .js-contact-thankyou-overlay').hide();
}

$('body').on('click', '.js-contact-popup', function(e) {
    e.preventDefault();
    $('.js-contact-popup-form .wpcf7-textarea').val('');
    $('.js-contact-popup-form, .js-contact-popup-overlay').fadeIn();
    $('.js-contact-popup-svg').addClass('active');
    $('body').addClass('o-hidden');

    // Check for digital marketing pages and check "Digital Marketing" input by default
    const firstStringURL = new URL(location.href).pathname.split("/")[1];
        
    if(firstStringURL == 'digital-marketing'){
        // showDigitalMarketingAreas();

        pickTheTopicValue.each(function(){
            let pickTheTopicCheckboxValue = $(this).val();
            
            if(pickTheTopicCheckboxValue == 'Digital Marketing'){
                $(this).prop('checked', true);
            }
        });
    }
});

$('body').on('click', '.section--portfolio .js-contact-popup', function(e) {
    let txt = $(this).parent().parent().children('.portfolio-name').text();
    let trimmedTxt = $.trim(txt);
    $('.page-template-ecommerce .js-contact-popup-form .wpcf7-textarea').val('How did you work on "'+trimmedTxt+'"?');
});

if( isMobile ){
    $('.js-contact-popup-close, .js-contact-popup-overlay').on('click', function(){
        contactPopupCloseContactMobile();
    });

    $('body').on('click', '.js-contact-popup', function(e) {
        e.preventDefault();

        $('.navbar-toggler[aria-expanded=true]').trigger('click');
    });
}else{
    $('.js-contact-popup-close, .js-contact-popup-overlay').on('click', function(){
        contactPopupClose();
    });

    $(document).on('keyup', function(e) {
        if (e.key === "Escape") { 
            contactPopupClose();
            contactThankYouPopupClose();
        }
    });
}

// Header button toggler click on mobile adding header--active-mobile class on header--home elemet
$('.navbar-toggler').on('click', function(){
    $(this).toggleClass('is-toggled');
    $('body').toggleClass('navbar-active');

    if($(this).attr('aria-expanded') == 'true' || $(this).hasClass('is-toggled')){
        $('.header--home').addClass('header--active-mobile');
    }else{
        setTimeout(function(){
            $('.header--home').removeClass('header--active-mobile');
        }, 300);
    }
});

$('body').on('keyup', function (e) {
    if (e.which === 27) {
        $('.header--home').removeClass('header--active-mobile');
        $('.navbar-toggler').removeClass('is-toggled');
        $('body').removeClass('navbar-active');
        $('.navbar-collapse').slideUp();
    }
});

$('.js-body-overlay').on('click', function(){
    $('.navbar-toggler').removeClass('is-toggled');
    $('body').removeClass('navbar-active');
    $('.navbar-collapse').slideUp();

    if($('.navbar-toggler').attr('aria-expanded') == 'true' || $('.navbar-toggler').hasClass('is-toggled')){
        $('.header--home').removeClass('header--active-mobile');
    }else{
        setTimeout(function(){
            $('.header--home').addClass('header--active-mobile');
        }, 300);
    }
});

// Contact form thank you popup close
$('body').on('click', '.js-contact-popup-close, .js-contact-thankyou-overlay', function(){
    contactThankYouPopupClose();
});

// Contact Form 7 onsent event fire
document.addEventListener('wpcf7mailsent', function(event) {
  if (!$('.js-ecommerce-popup-form').hasClass('active')) {
    let originalText = '<div class="contact-popup__header">Thank you for your message. It has been sent. <a class="buttonstandard buttonstandard--primary contact-popup__return" href="/">Return to Homepage <i class="fa-solid fa-arrow-right"></i></a></div>';
    contactPopupClose();
    if ( 'Ebook Sent' == event.detail.apiResponse.message) {
        $('.ebook__modal-form').html('<div class="contact-popup__header">Your free ebook is waiting for you. <br>Check your e-mail.</div>');
    } else {
        if (![13384, 9876, 13674].includes(event.detail.apiResponse.contact_form_id)) {
            $('form:not(.wpcf7-custom) .ebook__modal-form').html(originalText);
            $('.js-contact-thankyou, .js-contact-thankyou-overlay').show();
        }
    }
  }
}, false);

/**
 * Removing no-js class on body element on onload event
 * This is to prevent layout shift specially on slider elements when page is still loading
 */
$(window).on('load', function(){
    $('#wpadminbar .avatar').attr('alt', 'createit');
    $('body').removeClass('no-js');
    bodyPaddingTop();
});

$(window).on('resize', function(){
    bodyPaddingTop();
});

/**
 * Get ContactForm7 values and submit to activecampaign form
*/
$('form.wpcf7-form input[type="submit"]').on('click', function() {
    var parentElement = $(this).closest("form");
    var contactName = parentElement.find('input[name="fullname"]').val();
    var contactEmail = parentElement.find('input[type="email"]').val();
    var contactMessage = parentElement.find('textarea').val();
    var contactConsent = parentElement.find('input[type="checkbox"]').is(":checked");
    var contactReferrer = contactForm7FormTitles(parentElement.find('input[name="_wpcf7"]').val());
    let form = $('form._form._form_37');
    if(window.location.hash) {
        let hash = window.location.hash.substring(1);
        // Fragment
        $('#from-url').val(hash);
        if(hash === 'ecommerce'){
            form = $('form._form._form_47');
            contactReferrer = contactForm7FormTitles('865');
        }

        if(hash === 'igaming'){
            form = $('form._form._form_49');
            contactReferrer = contactForm7FormTitles('12935');
        }
    }
    form.find('input[data-name="full_name"]').val(contactName);
    form.find('input[data-name="email"]').val(contactEmail);
    form.find('textarea[data-name="message"]').val(contactMessage);
    form.find('input[data-name="consentagreement"]').attr("checked", contactConsent);
    form.find('input[data-name="referrer"]').val(contactReferrer);
    console.log('form', form);
    form.find('._submit').trigger('click');

});

function contactForm7FormTitles(id) {
    var title = '';
    switch (id) {
        case '1935':
                title = 'Contact form';
            break;
        case '12935':
                title = 'Contact Form iGaming';
            break;
        case '361':
                title = 'Contact Popup';
            break;
        case '865':
                title = 'Contact Popup Ecommerce';
            break;
        case '649':
                title = 'Contact Us';
            break;
        case '481':
                title = 'Ebook ecommerce form';
            break;
        case '307':
                title = 'Ebook form';
            break;
        case '306':
                title = 'Footer form';
            break;
        case '1704':
                title = 'Free Estimation';
            break;
        case '1134':
                title = 'Outsourcing form';
            break;
        case '808':
                title = 'Personal data access';
            break;
        case '1828':
                title = 'Web & Mobile Contact Form';
            break;
    
        default:
                title = 'Form ID: ' + id;
            break;
    }

    return title;
}

// Single careers page header nav item change to careers page active
$('.single-careers .nav-item .nav-link').each(function(){
    const menuItemLink = $(this).data('hover').trim();

    if(menuItemLink == 'Careers'){
        $(this).addClass('active');
    }else{
        $(this).removeClass('active');
    }
});

// Single our work page header nav item change to our work page active
$('.single-our_work .nav-item .nav-link').each(function(){
    const menuItemLinkWork = $(this).data('hover').trim();

    if(menuItemLinkWork == 'Our Work'){
        $(this).addClass('active');
    }else{
        $(this).removeClass('active');
    }
});

// Remove focus state on all buttons after clicking
$('body').on('click', 'button', function(e) {
    $(this).trigger("blur");
});